import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "首页", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "平均二维码", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 创建二维码 ")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "数据总览", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "研究生信息", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "订单管理", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "学员管理", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "找研友", -1)

import {
  Guide,
  // DataAnalysis,
  DocumentCopy,
} from "@element-plus/icons-vue";
import { useRoute } from "vue-router";
import { watch, ref } from "vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
watch(
  () => route.path,
  () => {
    switch (route.path) {
      case "/index":
        active.value = "1";
        break;
      case "/qrcode":
        active.value = "2-1";
        break;
      case "/":
        active.value = "2-2";
        break;
      // case "/analysis":
      //   active.value = "3-1";
      //   break;
      case "/postgraduate":
        active.value = "3";
        break;
      case "/order":
        active.value = "4";
        break;
      case "/student":
        active.value = "5";
        break;
      case "/find":
        active.value = "6";
        break;
      default:
        active.value = "";
    }
  }
);
const active = ref("1");
const handleOpen = (key: string, keyPath: string[]) => {
  console.log(key, keyPath);
};
const handleClose = (key: string, keyPath: string[]) => {
  console.log(key, keyPath);
};

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_menu_item_group = _resolveComponent("el-menu-item-group")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createBlock(_component_el_row, { class: "tac" }, {
    default: _withCtx(() => [
      _createVNode(_component_el_col, { span: 24 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_menu, {
            "default-active": active.value,
            "default-openeds": ['1'],
            class: "el-menu-vertical-demo",
            "active-text-color": "#67C23A",
            onOpen: handleOpen,
            onClose: handleClose
          }, {
            default: _withCtx(() => [
              _createVNode(_component_router_link, { to: "/index" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_menu_item, { index: "1" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(DocumentCopy))
                        ]),
                        _: 1
                      }),
                      _hoisted_1
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_sub_menu, { index: "2" }, {
                title: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Guide))
                    ]),
                    _: 1
                  }),
                  _hoisted_2
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_menu_item_group, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_router_link, { to: "/qrcode" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_menu_item, { index: "2-1" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_icon, null, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(DocumentCopy))
                                ]),
                                _: 1
                              }),
                              _hoisted_3
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_router_link, { to: "/" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_menu_item, { index: "2-2" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_icon, null, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(DocumentCopy))
                                ]),
                                _: 1
                              }),
                              _hoisted_4
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, { to: "/postgraduate" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_menu_item, { index: "3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(DocumentCopy))
                        ]),
                        _: 1
                      }),
                      _hoisted_5
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, { to: "/order" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_menu_item, { index: "4" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(DocumentCopy))
                        ]),
                        _: 1
                      }),
                      _hoisted_6
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, { to: "/student" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_menu_item, { index: "5" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(DocumentCopy))
                        ]),
                        _: 1
                      }),
                      _hoisted_7
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, { to: "/find" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_menu_item, { index: "6" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(DocumentCopy))
                        ]),
                        _: 1
                      }),
                      _hoisted_8
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["default-active"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})